module.exports = __webpack_public_path__ + "static/media/SolaTherapyLogo.5e52b2b3.png";